module.exports = new __parcel__URL__("TrelloSelectBoardIllustrationSpork.07ab7f27.svg").toString();